// Sidebar — left nav with logo, links, and user-footer per spec §8.
// Per Q7: hide Home in v1 nav; only show Support. Logo navigates to '/'.

import { Link, NavLink } from 'react-router';
import { MessageSquare, LogOut } from 'lucide-react';
import { useAuth, signOut } from '../../lib/auth';
import logoBlack from '../../assets/solomon-logo-black.svg';

export function Sidebar(): React.ReactNode {
  const { clientUser } = useAuth();

  const handleSignOut = async (): Promise<void> => {
    await signOut();
    // signOut does not redirect; the Supabase auth state change will kick the
    // ProtectedRoute redirect to /login.
  };

  return (
    <aside
      aria-label="Portal navigation"
      className="hidden md:flex md:w-60 md:flex-col md:border-r md:border-border-med md:bg-white"
    >
      <div className="flex h-full flex-col px-6 py-8">
        <Link
          to="/"
          aria-label="Solomon Advising — home"
          className="block px-2 py-2 focus-visible:rounded-sm"
        >
          <img
            src={logoBlack}
            alt="Solomon Advising"
            className="h-7 w-auto"
            loading="eager"
          />
        </Link>

        <hr className="my-6 border-border-light" />

        <nav className="flex flex-1 flex-col gap-1" aria-label="Primary">
          <NavLink
            to="/support"
            className={({ isActive }) =>
              [
                'flex items-center gap-3 rounded-sm px-3 py-2 text-[14px] font-medium transition-colors',
                isActive
                  ? 'bg-cream text-text-dark'
                  : 'text-text-body hover:bg-cream hover:text-text-dark',
              ].join(' ')
            }
          >
            <MessageSquare className="h-4 w-4" aria-hidden />
            <span>Support</span>
          </NavLink>
        </nav>

        {clientUser ? (
          <>
            <hr className="my-6 border-border-light" />
            <div className="space-y-1 px-3">
              <p className="text-[14px] font-medium text-text-dark">
                {clientUser.full_name ?? clientUser.email}
              </p>
              <p className="text-[12px] text-text-muted">{clientUser.company_name}</p>
              <button
                type="button"
                onClick={() => {
                  void handleSignOut();
                }}
                className="mt-3 inline-flex items-center gap-2 text-[13px] font-medium text-text-body transition-colors hover:text-orange"
              >
                <LogOut className="h-4 w-4" aria-hidden />
                Sign out
              </button>
            </div>
          </>
        ) : null}
      </div>
    </aside>
  );
}
